'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Svg = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends__default["default"]({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M23.998 19v1.988a.95.95 0 0 1-.28.7c-.187.186-.43.29-.728.308H1.008a.907.907 0 0 1-.7-.308 1.139 1.139 0 0 1-.308-.7V19c0-.28.103-.514.308-.7.205-.187.439-.29.7-.309H22.99c.28 0 .522.103.728.308.205.206.298.44.28.7Zm0-8.009v2.016c0 .261-.094.495-.28.7-.187.205-.43.299-.728.28H1.008a.95.95 0 0 1-.7-.28 1.054 1.054 0 0 1-.308-.7v-2.016c0-.261.103-.495.308-.7.205-.205.439-.299.7-.28H22.99c.28 0 .522.093.728.28.205.187.298.42.28.7Zm0-7.98v1.988c0 .26-.094.494-.28.7a.938.938 0 0 1-.728.308H1.008a.907.907 0 0 1-.7-.308 1.139 1.139 0 0 1-.308-.7V3.01c0-.28.103-.522.308-.728.205-.205.439-.298.7-.28H22.99c.28 0 .522.094.728.28.205.187.298.43.28.728Z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
});
var BurgerMenu = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement(react.Icon, _extends__default["default"]({
    as: Svg
  }, props, {
    ref: ref
  }));
});
exports.BurgerMenu = BurgerMenu;